import * as React from 'react';

import { Box, Flex } from '@lightspeed/flame/Core';
import { Text } from '@lightspeed/flame/Text';

import { BarcodeSyncStatus } from 'root/apps/InventoryCountScanQueue/BarcodeService';

import { ScanStatus } from '../types';
import {
  StyledDateTimeWidth,
  StyledItemDescriptionWidth,
  StyledItemIdWidth,
} from '../views/ScanQueue.style';

interface ScannedRow {
  barcode: string;
  time: string;
  status: BarcodeSyncStatus;
  description?: string;
  id?: number;
}

export const ScanRow: React.FC<ScannedRow> = ({ barcode, time, status, description, id }) => {
  return (
    <Box px={4} py={2} m={0} data-test={`scan-queue-listing-${status}-${id}`}>
      <Flex
        flexDirection="row"
        justifyContent="space-between"
        alignItems="center"
        style={{ overflow: 'hidden' }}
      >
        <StyledItemIdWidth>
          <Text fontSize={14} data-test={`scan-queue-barcode-${status}`} className="notranslate">
            {barcode}
          </Text>
        </StyledItemIdWidth>
        <StyledItemDescriptionWidth>
          {status === ScanStatus.Done ? (
            <Text
              fontSize={14}
              className="notranslate"
              data-test={`scan-queue-item-description-${status}`}
            >
              {description}
            </Text>
          ) : null}
        </StyledItemDescriptionWidth>
        <StyledDateTimeWidth>
          <Text fontSize={14} data-test={`scan-queue-time-${status}`} className="notranslate">
            {time}
          </Text>
        </StyledDateTimeWidth>
      </Flex>
    </Box>
  );
};
